export default {"src":"/_next/static/media/berry-street-logo-white.fbf1e105.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};